import {Injectable} from '@angular/core';
import {ActivatedRoute, Resolve, Router} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from '../services/api.service';
import {forkJoin} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CategoryResolver implements Resolve<any> {

  constructor(public apiService: ApiService,
              public translate: TranslateService) {
  }


  resolve(route: ActivatedRouteSnapshot) {
    const call1 = this.apiService.getCategory( Number(route.paramMap.get('id')));
    return forkJoin([call1])
  }
}
